import { useQuery } from "react-query";
import { AdoMetricResult } from "../api/aiMetricsApi";
import { adoPriorQueryKey } from "./adoQueryKeys";

type MetricFetcher = (
  teams: string[],
  startDate: Date,
  endDate: Date,
  sprints: string[],
) => Promise<AdoMetricResult[]>;

export function makeAdoMetricHook(queryKey: string, fetcher: MetricFetcher) {
  return (
    teams: string[],
    startDate: Date,
    endDate: Date,
    priorStartDate: Date,
    priorEndDate: Date,
    comparisonEnabled = true,
    sprints: string[] = [],
  ) => {
    const sprintsKey = JSON.stringify([...sprints].sort());
    const current = useQuery<AdoMetricResult[], Error>(
      [
        queryKey,
        JSON.stringify([...teams].sort()),
        startDate.toISOString(),
        endDate.toISOString(),
        sprintsKey,
      ],
      () => fetcher(teams, startDate, endDate, sprints),
      { staleTime: 5 * 60 * 1000, enabled: teams.length > 0 },
    );
    const prior = useQuery<AdoMetricResult[], Error>(
      [
        adoPriorQueryKey(queryKey),
        JSON.stringify([...teams].sort()),
        priorStartDate.toISOString(),
        priorEndDate.toISOString(),
        sprintsKey,
      ],
      () => fetcher(teams, priorStartDate, priorEndDate, sprints),
      {
        staleTime: 5 * 60 * 1000,
        enabled: teams.length > 0 && comparisonEnabled,
      },
    );
    return { current, prior };
  };
}
